<template>
   <div class="right">
      <div class="title-box">
        <span class="curr">发起单位</span>
      </div>
      <div class="list">
        <div class="item flexH">
          <img src="@/assets/img/icon_gongsi_img1.png" alt="">
          <div>
            <h3 class="fontE1">北明软件有限公司</h3>
            <p>北明软件有限公司（以下简称“北明软件“，系常山北明全资子公司，股票代码：000158）于1998年在中国广州成立，注册资本金7.387亿元人民币，致力于为金融、电力、能源、政府、互联网/运营商、公共事业、制造业等行业提供综合……</p>
          </div>
        </div>
        <div class="item flexH">
          <img src="@/assets/img/icon_gongsi_img2.png" alt="">
          <div>
            <h3 class="fontE1">贤牛（北京）科技有限公司</h3>
            <p class="fontE3">贤牛（北京）科技有限公司成立于2018年4月，致力于打造IT后市场数字化平台，推动IT服务供应链的数字化转型与商业创新。基于3S（SCaaS、SaaS、Support Service）商业架构体系，贤牛能够对各类IT服务商赋能，帮助客户持续增……</p>
          </div>
        </div>
        <div class="item flexH">
          <img src="@/assets/img/icon_gongsi_img3.png" alt="">
          <div>
            <h3 class="fontE1">中国石化集团共享服务有限公司</h3>
            <p>为深化企业内部改革、促进职能转型和资源整合、提高整体管理水平和运行效率、增强风险防控能力、实现全面可持续发展，中国石化积极响应国家“互联网+”战略和两化融合要求，于2013年率先开展财务共享服务试点，启动共享服务建设……</p>
          </div>
        </div>
      </div>
   </div>
</template>
<script>
export default {
  data() {
    return {
      leftList: [
        '会员服务',
        '发起单位',
        '企业名录',
        '企业风采',
        '人物专访',
        '会员表彰',
        '企业展示',
        '会员申请',
      ]
    }
  }
};
</script>
<style lang="less" scoped>

.right {
  width: 905px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  padding: 30px;
  .list {
    .item {
      padding: 30px 0;
      border-bottom: 1px solid #f8f8fb;
      img {
        width: 274px;
        height: 142px;
        margin-right: 58px;

      }
      h3 {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #171717;
        line-height: 30px;
      }
      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5F5F6A;
        line-height: 24px;
        margin-top: 13px;
      }
    }
  }
}

.title-box {
  padding: 0 0 21px 0;
  border-bottom: 1px solid #f8f8fb;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #909097;
    line-height: 28px;
    margin-right: 40px;
    position: relative;
    &.curr {
      color: #1b252c;
      &::after {
        width: 96px;
        height: 2px;
        background: #0d53bc;
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }
}
</style>
